import { combineReducers } from "redux";
import { reducer as getEssentialServicesGeojson } from "./actions/getEssentialServicesGeojson";

export const pontosessenciais = combineReducers({
  getEssentialServicesGeojson
});
